import { render, staticRenderFns } from "./AxSelect.vue?vue&type=template&id=c226abec&scoped=true"
import script from "./AxSelect.vue?vue&type=script&lang=ts"
export * from "./AxSelect.vue?vue&type=script&lang=ts"
import style0 from "./AxSelect.vue?vue&type=style&index=0&id=c226abec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c226abec",
  null
  
)

export default component.exports